/* eslint-disable no-empty */
import { useUserContext } from "Hooks/UserContext";
import React, { useContext, useEffect, useState } from "react";

import { useLocation } from "react-router-dom";
import { NavLink, useNavigate } from "react-router-dom";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  SearchOutlined,
  UserOutlined,
  LockOutlined
} from "@ant-design/icons";
import {
  Layout,
  Menu,
  Button,
  Switch,
  Flex,
  Row,
  Col,
  theme,
  Modal,
  Grid,
  Avatar,
  Popover,
  Divider,
  Typography,
  Tooltip
} from "antd";
import { ColorModeContext } from "Helpers/contexts";
import { MenuList } from "Static/utils/menuList";

import myLogo from "Static/img/dual_logo.svg";
// import darkLogo from "Static/img/dark_logo.svg";
import collapse_Logo from "Static/img/collapse_logo.svg";
import BreadcrumbBox from "./BreadcrumbBox";
import { excludedBreadCrumb, excludedPaths, returnMenuIcon } from "Helpers/ats.constants";
import { useServices } from "Hooks/ServicesContext";
import { useQuery } from "react-query";
import { Paths } from "Router/Paths";
import { excludeBreadCrumbs, isDesktopScreen } from "Helpers/ats.helper";
import SearchMenuModal from "./Modals/SearchMenuModal";
import useScreenType from "Components/customHooks/useScreenType";
import { KycAdminPaths } from "Router/KYCAdminPaths";

const { SubMenu } = Menu;

// import { ColorModeContext } from "Helpers/contexts";
const { Header, Sider, Content } = Layout;

const HeaderLayout = ({ children }) => {
  const [userTypecheck, setUsertype] = React.useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [isMenuPopupOpen, setIsMenuPopupOpen] = useState(false);
  const { colorMode, mode } = useContext(ColorModeContext);
  const { toggleColorMode } = colorMode;
  const {
    token: { colorBgContainer, colorBorder, paddingLG, paddingSM, colorText }
  } = theme.useToken();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const screenType = useScreenType();

  React.useEffect(() => {
    const userType = localStorage.getItem("crmUser");
    setUsertype(userType == "true" ? true : false);
  }, [localStorage.getItem("crmUser")]);

  // Keyboard shortcut for search modal
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.altKey && e.key.toLowerCase() === "q") {
        e.preventDefault();
        setIsMenuPopupOpen((prev) => !prev);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const location = useLocation();
  const { apiService } = useServices();
  const StyleSheet = {
    BreadcrumbRowStyle: {
      padding: "0px 0px 12px 0px"
    },
    boxStyle: {
      width: "100%",
      padding: paddingLG,
      textAlign: "left"
    },
    collapseBoxStyle: {
      width: "100%",
      padding: paddingLG,
      alignItems: "center"
    },
    contentSubStyle: {
      padding: screenType === "mobile" ? 0 : "24px",
      minHeight: "calc(100vh - 130px)",
      background: colorBgContainer,
      border: `1px solid ${colorBorder}`,
      borderRadius: "10px"
    },
    contentSubNoStyle: {
      padding: "0",
      border: `0`,
      borderRadius: "0"
    },
    logoStyle: {
      maxWidth: "100%",
      height: "28px"
    },
    collapseLogoStyle: {
      alignItems: "center",
      width: "30px"
    },

    headerStyle: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      width: "100%"
    },
    sideBarStyle: {
      overflow: "auto",
      height: "100vh",
      position: "fixed",
      left: 0,
      top: 0,
      bottom: 0,
      borderRight: `1px solid ${colorBorder}`,
      width: "300px",
      maxWidth: "300px",
      minWidth: "300px",
      zIndex: "66"
    },
    headerStyleMain: {
      position: "sticky",
      top: 0,
      zIndex: 99,
      width: "100%",
      borderBottom: `1px solid ${colorBorder}`,
      ...(screenType === "mobile" && { padding: 0 })
    },
    contentStyle: {
      paddingTop: paddingSM,
      paddingBottom: paddingSM,
      paddingLeft: screenType === "mobile" ? 0 : paddingLG,
      paddingRight: screenType === "mobile" ? 0 : paddingLG
    },
    contentNoStyle: {
      // paddingTop: paddingSM,
      // paddingBottom: paddingSM,
      // paddingLeft: paddingLG,
      // paddingRight: paddingLG,
      background: colorBgContainer
    },
    mainPaddingStyle: {
      paddingTop: paddingSM,
      paddingBottom: 0,
      paddingLeft: paddingLG,
      paddingRight: paddingLG
    },
    backNameStyle: {
      marginRight: screenType === "mobile" ? "0px" : "12px",
      fontWeight: 500,
      color: colorText
    }
  };
  const navigate = useNavigate();

  const { setLoggedIn, setuserDetails, userDetails, setPermission, permission } = useUserContext();
  const [modules, setModules] = useState([]);
  const [maintenanceEndDate, setMaintenanceEndDate] = useState(null);
  const [ecomModules, setEcomModules] = useState([]);
  const [ecomMaintenanceEndDate, setEcomMaintenanceEndDate] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const returnParentPath = () => {
    try {
      const path = location.pathname.replace(/^\//, "");
      const collectPaths = (items) => {
        let out = [];
        items?.forEach((it) => {
          if (it?.path) out.push(it.path);
          if (it?.subMenu?.length) out = out.concat(collectPaths(it.subMenu));
        });
        return out;
      };
      const allPaths = collectPaths(MenuList);
      let best = "";
      for (const p of allPaths) {
        if ((path === p || path.startsWith(p + "/")) && p.length > best.length) {
          best = p;
        }
      }
      if (best) return [best];
      const first = path.match(/^([^/]+)/);
      return first ? [first[1]] : [];
    } catch (error) {
      return [];
    }
  };

  /**
   * Function to show modal
   */
  const showModal = () => {
    setIsModalOpen(true);
  };

  /**
   * Function to handle logout
   */
  const handleLogout = () => {
    localStorage.clear();
    setuserDetails({});
    setLoggedIn(false);
    navigate("/");
    !mode === true ? toggleColorMode() : "";
    setIsModalOpen(false);
  };
  /**
   * Function to handle cancel pop up
   */
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  /**
   * fetch permission list
   */
  useQuery(
    "permissionlist",
    // Function to fetch role data using apiService.getRoleData
    () => apiService.getRolePermission(`${userDetails.user_role}`),
    {
      // Configuration options
      enabled: true, // Initial fetch is disabled
      onSuccess: (data) => {
        if (data?.data && data?.data?.modulePermissions) {
          setPermission(data.data.modulePermissions);
          localStorage.setItem("slugPermission", JSON.stringify(data.data.modulePermissions));
        }
      },
      onError: (error) => {
        // Handle errors by displaying a Snackbar notification
        setPermission(null);
      }
    }
  );

  // Fetch KYC config and set modules, global maintenance flag, and maintenance end date
  useQuery("kycConfig", () => apiService.getKycConfig(), {
    onSuccess: (res) => {
      if (res?.data) {
        setModules(res.data.modules || []);
        setMaintenanceEndDate(res.data.end_date || null);
      }
    }
  });

  const maintenanceMap = React.useMemo(() => {
    return modules.reduce((acc, cur) => {
      acc[cur.module_slug] = cur.maintenance_mode;
      return acc;
    }, {});
  }, [modules]);

  const flattenMenus = (list = []) =>
    list.flatMap((i) => (i.subMenu?.length ? flattenMenus(i.subMenu) : i));

  const normalize = (p = "") => p.replace(/^\/+|\/+$/g, "");

  const goToMaintenance = (item) => {
    if (!maintenanceMap[item.module_slug]) return;

    navigate(`${KycAdminPaths.kycMaintenance}?module=${item.module_slug}`, {
      state: {
        module: item.title,
        moduleSlug: item.module_slug,
        endDate: maintenanceEndDate
      }
    });
  };

  useEffect(() => {
    if (!modules.length) return;

    const allMenus = flattenMenus(MenuList);

    const currentMenu = allMenus.find((m) => normalize(m.path) === normalize(location.pathname));
    if (
      currentMenu?.module_slug &&
      maintenanceMap[currentMenu.module_slug] &&
      !location.pathname.startsWith(KycAdminPaths.kycMaintenance)
    ) {
      navigate(`${KycAdminPaths.kycMaintenance}?module=${currentMenu.module_slug}`, {
        replace: true,
        state: {
          module: currentMenu.title,
          moduleSlug: currentMenu.module_slug,
          endDate: maintenanceEndDate,
          fromPath: location.pathname
        }
      });
    }
  }, [location.pathname, maintenanceMap, modules]);

  // Fetch MDM (ecom) config and set ecom modules and maintenance end date
  const { refetch: refetchMdmConfig } = useQuery("mdmConfig", () => apiService.getMdmConfig(), {
    onSuccess: (res) => {
      if (res?.data) {
        setEcomModules(res.data.modules || []);
        setEcomMaintenanceEndDate(res.data.end_date || null);
      }
    }
  });

  // Re-check ecom maintenance on every navigation, so a schedule that starts while the app is open is applied
  const isFirstEcomCheck = React.useRef(true);
  useEffect(() => {
    if (isFirstEcomCheck.current) {
      isFirstEcomCheck.current = false;
      return;
    }
    refetchMdmConfig();
  }, [location.pathname]);

  const ecomMaintenanceMap = React.useMemo(() => {
    return ecomModules.reduce((acc, cur) => {
      acc[cur.module_slug] = cur.maintenance_mode;
      return acc;
    }, {});
  }, [ecomModules]);

  // Redirect to maintenance page when the current MDM (ecom) module is under maintenance
  useEffect(() => {
    if (!ecomModules.length) return;

    const allMenus = flattenMenus(MenuList);

    const currentMenu = allMenus.find((m) => normalize(m.path) === normalize(location.pathname));
    if (
      currentMenu?.module_slug &&
      ecomMaintenanceMap[currentMenu.module_slug] &&
      !location.pathname.startsWith(KycAdminPaths.kycMaintenance)
    ) {
      navigate(`${KycAdminPaths.kycMaintenance}?module=${currentMenu.module_slug}`, {
        replace: true,
        state: {
          module: currentMenu.title,
          moduleSlug: currentMenu.module_slug,
          endDate: ecomMaintenanceEndDate,
          fromPath: location.pathname
        }
      });
    }
  }, [location.pathname, ecomMaintenanceMap, ecomModules]);

  const getOpenKeys = (pathname) => {
    const path = (pathname || "").replace(/^\/+|\/+$/g, "");
    for (const item of MenuList) {
      if (item.subMenu) {
        for (const sub of item.subMenu) {
          if (sub.path === path || (sub.path && path.startsWith(sub.path + "/"))) {
            return [item.title];
          }
          if (sub.subMenu) {
            for (const nested of sub.subMenu) {
              if (nested.path === path || (nested.path && path.startsWith(nested.path + "/"))) {
                return [item.title, `${item.title}/${sub.title}`];
              }
            }
          }
        }
      }
    }
    return [];
  };

  const [openKeys, setOpenKeys] = useState(() => getOpenKeys(location.pathname));

  useEffect(() => {
    setOpenKeys(getOpenKeys(location.pathname));
  }, [location.pathname]);

  const onOpenChange = (keys) => {
    try {
      const latestKey = keys[keys.length - 1];
      if (!latestKey || (latestKey.includes("/") && !keys.includes(latestKey.split("/")[0]))) {
        return setOpenKeys([]);
      }
      setOpenKeys(latestKey.includes("/") ? [latestKey.split("/")[0], latestKey] : [latestKey]);
    } catch (error) {}
  };

  useEffect(() => {
    // sidebar defualt close on tablet view
    const handleResize = () => {
      if (window.innerWidth <= 1024) {
        setCollapsed(true);
      } else {
        setCollapsed(false);
      }
    };

    // Initial check
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // function to check path and exclude css
  const getStyleForPathname = (pathname) => {
    // Check if the pathname includes any of the excluded paths
    const isExcluded = excludedPaths.some((path) => pathname.includes(path));
    return isExcluded ? StyleSheet.contentSubNoStyle : StyleSheet.contentSubStyle;
  };
  const currentStyle = getStyleForPathname(location.pathname);

  return (
    <>
      <Layout>
        <Sider
          width="255"
          collapsedWidth="60"
          style={StyleSheet.sideBarStyle}
          trigger={null}
          collapsible
          collapsed={collapsed}>
          <div className="demo-logo-vertical" />

          <Flex
            style={collapsed ? StyleSheet.collapseBoxStyle : StyleSheet.boxStyle}
            justify={"space-between"}
            align={"center"}
            {...(!isDesktopScreen(screens) && { vertical: "true" })}
            gap={24}>
            <NavLink to={userTypecheck == true ? Paths.Crm : Paths.users}>
              <img
                style={collapsed ? StyleSheet.collapseLogoStyle : StyleSheet.logoStyle}
                src={collapsed ? collapse_Logo : !mode ? myLogo : myLogo}
                alt=""
              />
            </NavLink>
            <Tooltip title="Alt + Q">
              <SearchOutlined
                className="header__menu__search"
                onClick={() => setIsMenuPopupOpen(!isMenuPopupOpen)}
              />
            </Tooltip>
          </Flex>

          <Menu
            mode="inline"
            theme={!mode ? "dark" : "light"}
            defaultSelectedKeys={returnParentPath()}
            selectedKeys={returnParentPath()}
            openKeys={collapsed ? [] : openKeys}
            onOpenChange={onOpenChange}>
            <Menu.Item
              key={userTypecheck == true ? Paths.Crm : Paths.users}
              icon={returnMenuIcon("dashboard")}>
              <NavLink to={userTypecheck == true ? Paths.Crm : Paths.users}>{"Dashboard"}</NavLink>
            </Menu.Item>
            {MenuList.filter((item) =>
              permission?.some(
                (mainitem) =>
                  (mainitem?.module_slug === item.module_slug ||
                    item.module_slug.includes(mainitem?.module_slug)) &&
                  mainitem?.permissions?.length > 0
              )
            ).map((item, index) =>
              item?.subMenu?.length > 0 ? (
                <SubMenu key={item.title} icon={returnMenuIcon(item.icon)} title={item.title}>
                  {item.subMenu
                    .filter((subItem) =>
                      permission?.some(
                        (mainitem) =>
                          (mainitem?.module_slug === subItem.module_slug ||
                            subItem.module_slug.includes(mainitem?.module_slug)) &&
                          mainitem?.permissions?.length > 0
                      )
                    )
                    ?.map((subItem, subIndex) =>
                      subItem?.subMenu?.length > 0 ? (
                        <SubMenu
                          key={`${item.title}/${subItem.title}`}
                          icon={returnMenuIcon(subItem.icon)}
                          title={subItem.title}>
                          {subItem.subMenu
                            .filter((subItemm) =>
                              permission?.some(
                                (mainitemm) =>
                                  subItemm.module_slug.includes(mainitemm?.module_slug) &&
                                  mainitemm?.permissions?.length > 0
                              )
                            )
                            ?.map((subItemm, subIndexx) => (
                              <Menu.Item
                                key={subItemm.path}
                                onClick={() => goToMaintenance(subItemm)}>
                                <NavLink to={subItemm.path}>{subItemm.title}</NavLink>
                              </Menu.Item>
                            ))}
                        </SubMenu>
                      ) : (
                        <Menu.Item key={subItem.path} onClick={() => goToMaintenance(subItem)}>
                          <NavLink to={subItem.path}>{subItem.title}</NavLink>
                        </Menu.Item>
                      )
                    )}
                </SubMenu>
              ) : (
                <Menu.Item key={item.path} icon={returnMenuIcon(item.icon)}>
                  <NavLink to={item.path}>{item.title}</NavLink>
                </Menu.Item>
              )
            )}
          </Menu>
        </Sider>
        <Layout
          style={
            collapsed
              ? { minHeight: "100vh", marginLeft: 60 }
              : { minHeight: "100vh", marginLeft: 255 }
          }>
          <Header style={StyleSheet.headerStyleMain}>
            <Flex vertical justify={"center"} align="start" className="height_full">
              <Flex
                justify={"space-between"}
                align={"center"}
                gap={"middle"}
                className="width_full">
                <Button
                  type="text"
                  icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                  onClick={() => setCollapsed(!collapsed)}
                />
                <Popover
                  trigger="click"
                  placement="bottomRight"
                  arrow={false}
                  content={
                    <div style={{ minWidth: 260, maxWidth: 300 }}>
                      {/* User details */}
                      <Flex align="start" gap="small" style={{ padding: "4px 0 8px 0" }}>
                        <Avatar
                          size={36}
                          style={{ backgroundColor: "#8c8c8c", flexShrink: 0, fontSize: 14 }}>
                          {userDetails?.user_name
                            ? userDetails.user_name.charAt(0).toUpperCase()
                            : "U"}
                        </Avatar>
                        <div>
                          {userDetails?.dist_name && (
                            <Typography.Text
                              strong
                              style={{ fontSize: 13, display: "block", lineHeight: "20px" }}>
                              {userDetails.dist_name}
                            </Typography.Text>
                          )}
                          {userDetails?.ab_name && (
                            <Typography.Text
                              style={{ fontSize: 12, display: "block", color: "#595959" }}>
                              Store: {userDetails.ab_name}
                              {userDetails?.dist_no ? ` (${userDetails.dist_no})` : ""}
                            </Typography.Text>
                          )}
                          <Typography.Text
                            style={{ fontSize: 12, display: "block", color: "#595959" }}>
                            Name: {userDetails?.user_name || "-"}
                          </Typography.Text>
                          {userDetails?.user_phone_number && (
                            <Typography.Text
                              style={{ fontSize: 12, display: "block", color: "#595959" }}>
                              Mobile: {userDetails.user_phone_number}
                            </Typography.Text>
                          )}
                        </div>
                      </Flex>

                      <Divider style={{ margin: "8px 0" }} />

                      <Flex align="center" justify="space-between" style={{ padding: "4px 0" }}>
                        <Typography.Text style={{ fontSize: 13 }}>Theme</Typography.Text>
                        <Switch
                          checkedChildren="Dark"
                          unCheckedChildren="Light"
                          checked={!mode}
                          onChange={toggleColorMode}
                        />
                      </Flex>

                      <Divider style={{ margin: "8px 0" }} />

                      <Button
                        type="text"
                        icon={<LockOutlined />}
                        block
                        style={{ textAlign: "left" }}
                        onClick={() => navigate(Paths.changePassword)}>
                        Change Password
                      </Button>

                      <div
                        style={{
                          textAlign: "center",
                          padding: "6px 0",
                          cursor: "pointer",
                          borderRadius: 6,
                          transition: "background 0.2s"
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.background = "#fff1f0")}
                        onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                        onClick={showModal}>
                        <Typography.Text type="danger" style={{ fontSize: 14 }}>
                          Logout
                        </Typography.Text>
                      </div>
                    </div>
                  }>
                  {/* Header: Avatar + Name + Mobile visible upfront */}
                  <Flex align="center" gap="small" style={{ cursor: "pointer" }}>
                    <div style={{ textAlign: "right", lineHeight: 1.3 }}>
                      <Typography.Text strong style={{ fontSize: 13, display: "block" }}>
                        {userDetails?.user_name || "-"}
                      </Typography.Text>
                      {userDetails?.user_phone_number && (
                        <Typography.Text type="secondary" style={{ fontSize: 11 }}>
                          {userDetails.user_phone_number}
                        </Typography.Text>
                      )}
                    </div>
                    <Avatar
                      size="large"
                      style={{ backgroundColor: "#8c8c8c", flexShrink: 0 }}
                      icon={<UserOutlined />}
                    />
                  </Flex>
                </Popover>

                {/* Logout Modal */}
                <Modal
                  title="Logout"
                  okText="Yes"
                  cancelText="No"
                  okButtonProps={{ danger: true }}
                  open={isModalOpen}
                  onOk={handleLogout}
                  onCancel={handleCancel}>
                  <p>Are you sure you want to logout?</p>
                </Modal>
              </Flex>
            </Flex>
          </Header>
          <Content
            style={
              location.pathname.includes("product_add") ||
              location.pathname.includes("keysoul-template") ||
              location.pathname.includes("product_edit")
                ? StyleSheet.contentNoStyle
                : StyleSheet.contentStyle
            }>
            <div
              style={
                location.pathname.includes("product_add") ||
                location.pathname.includes("keysoul-template") ||
                location.pathname.includes("product_edit")
                  ? StyleSheet.mainPaddingStyle
                  : {}
              }>
              {/* excludeBreadCrumbs  */}
              {!excludeBreadCrumbs(location.pathname, excludedBreadCrumb) && (
                <Row gutter={16} style={StyleSheet.BreadcrumbRowStyle}>
                  <Col className="gutter-row" span={24}>
                    <BreadcrumbBox />
                  </Col>
                </Row>
              )}
            </div>

            <Content className="test" style={currentStyle}>
              {children}
            </Content>
          </Content>
        </Layout>
      </Layout>

      {/* Menu Search Modal */}
      <Modal
        open={isMenuPopupOpen}
        className="header__menu__popup"
        width={800}
        styles={{ mask: { backdropFilter: "blur(10px)" } }}
        destroyOnClose
        keyboard={true}
        onCancel={() => setIsMenuPopupOpen(false)}
        closeIcon={false}
        footer={false}>
        <SearchMenuModal
          isMenuPopupOpen={isMenuPopupOpen}
          setIsMenuPopupOpen={setIsMenuPopupOpen}
          contextPermission={permission}
        />
      </Modal>
    </>
  );
};

export default HeaderLayout;
